import { FC } from 'react';

type Props = {
  value?: string;
};
const PostCustomCell: FC<Props> = ({ value }) => {
  return <div>{value}</div>;
};

export { PostCustomCell };
